export const izvjestaj_inventura = {
  templateId: 209,
  category: 4,
  templateTitle: 'Izvještaj o provedenom popisu imovine i obveza',
  templateDescription: `<p>Inventurna/e komisija/e vaganjem, mjerenjem i drugim postupcima utvrđuju stvarno stanje imovine i unosi ga u popisne liste te  izvještava poduzetnika o stanju imovine i obveza. </p>`,
  description: `
  <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
  <p>Nakon što je inventurna komisija (jedna komisija može provesti cjelokupni popis, no poduzetnik može odlučiti da popis provede više komisija, svaka s različitim obujmom popisa) provela popis imovine i obveza, dužna je odgovornoj osobi poduzetnika u okviru Izvještaja o rezultatima inventure podnijeti odnosno utvrditi popisne razlike između knjigovodstvenog stanja i stvarnog stanja.  </p>
  <p>Primjer takvog Izvještaja nalazi se u nastavku, a isti može biti i manjeg obujma, ukoliko inventurna komisija obavlja popis dijela imovine i obveza - jedna komisija obavlja djelomičan popis. </p>
  <p>Kada je riječ o imovini, u odnosu na navedene popisne razlike (stvarno stanje u odnosu na knjigovodstveno stanje), postoji mogućnost  inventurnog viška ili inventurnog manjka.  </p>
  <p>Inventurni višak nastaje kada je stvarno stanje (količina) pojedine imovine veće od stanja (količine) iskazane u knjigama. </p>
  <p>Inventurni manjak postoji kad je stvarno stanje utvrđeno popisom manje od evidencija iskazanih u knjigama, za pojedinu skupinu imovine.  </p>
  <p>Ukoliko komisija konstatira da nema viškova niti manjkova, to obično znači da inventura nije provedena ili je provedena samo formalno.  </p>
  <p>Viškovi i manjkovi uobičajena su posljedica rukovanja s imovinom i često se javljaju kod poduzetnika s većim obujmom poslovanja.  </p>
  <p>Viškovi su najčešće se javljaju kod grešaka kod količinskog evidentiranja ulaza i izlaza, no i kao rezultat netočnog kvalitativnog zaprimanja ili evidentiranja krivog artikla.</p>
  <p>Do pogreške može doći u računovodstvu (pogrešno knjiženje) ili u nekom drugom odjelu (npr. zamjena šifre artikala pri evidenciji nabave u skladištu). </p>
  <p>Višak se u poslovnim knjigama iskazuje kao prihod (po procijenjenoj tržišnoj cijeni odnosno tzv. cijeni nove nabave). Prihod također može nastati (evidentiramo ga u knjigama) i kada iz poslovne dokumentacije postane razvidno da su obveze zastarjele ili da je vjerovnik u međuvremenu likvidiran, u kojem slučaju se obveze otpisaju i evidentiraju kao prihod.</p>
  <p>Prilikom evidentiranja prihoda od inventurnih viškova nema dodatnih oporezivanja niti oporezivanja PDV-om (prihod već sam po sebi uvećava osnovicu poreza na dobit), no ukoliko je riječ o zalihama robe i materijala, valja biti vrlo oprezan i ne prebijati viškove odnosno manjkove po različitim skupinama zaliha.   </p>
  <p>Manjkovi obično nastaju rastepom, kvarom, lomom, neažurnim i neredovitim evidentiranjem ulaza i izlaza, zamjenama, krađama,  istekom  roka trajanja i dr..</p>
  <p>U tom smislu, manjkovi utvrđeni inventurom dijele se na:  </p>
  <li> neoporezive manjkove, </li>
  <li> oporezive manjkove.  </li>
  <br> 
  <p>Više o tome, pročitajte u tekstovima ispred <a class="local-link" href="/contract?template=209.1">Odluke o knjiženju popisnih razlika (porezno priznati manjak)</a>  i <a class="local-link" href="/contract?template=209.2">Odluke o knjiženju popisnih razlika (porezno nepriznati manjak)</a>.</p>
 
  <p>Npr. Hrvatska gospodarska komora (za obveznike poreza na dobit) te Hrvatska obrtnička komora svojim Odlukama utvrđuju dopuštenu visinu manjka s osnove kala, rastepa, kvara, loma i tehnološkog manjka.   </p>

  <p>Također, sami poduzetnici mogu donijeti interne odluke o manjkovima (na temelju vlastitih iskustava u proizvodnom procesu), no svakako moraju navedeno propisno dokumentirati.</p>

  <p>U slučajevima kad nisu u primjeni Odluke komore za manjak ili nedostaju Odluke poduzetnika, Porezna uprava normative za manjkove procjenjuje na temelju međuovisnosti između prihoda i rashoda, putem normativa proizvodnih faktora (kriterij može biti utrošak materijala, energije i drugo).</p>

  <p>Važno je naglasiti da nije dopušten manjak dugotrajne imovine, novca, sitnog inventara, rezervnih dijelova i slično, nego se za isti utvrđuje odgovornost osobe zadužene za upravljanje tom imovinom, u suprotnom, riječ je o tzv. prekomjernom manjku.</p>

  <p>Osim toga, u slučaju provale ili elementarne nepogode, potrebno je sastaviti očevidnik odnosno knjigovodstveno evidentirati zapisnik (od strane službenog tijela) kako bi se točno evidentiralo knjigovodstveno i stvarno stanje robe.</p>

  <p>Nakon predočenja popisnih razlika te Izvještaja inventurne komisije o provedenoj inventuri, zakonski će predstavnik poduzetnika na temelju istih, ovisno o tome što je utvrđeno istima,  odlučiti o:</p>
  <li> načinu likvidacije utvrđenih manjkova, </li>
  <li> načinu knjiženja utvrđenih viškova, </li>
  <li> otpisu nenaplativih i zastarjelih potraživanja i obveza, </li>
  <li> rashodovanju sredstava, opreme i sitnog inventara,</li>
  <li> mjerama protiv osoba odgovornih za manjkove, oštećenja, neusklađenost knjigovodstvenog i stvarnog stanja, zastaru, nenaplativost potraživanja i slično.</li>
  
  `,
 
  sides: [
      {
          prefix: "Na temelju Odluke o provođenju popisa imovine i obveza te imenovanju komisije za popis imovine, u sljedećem sastavu:",
          signature: "Predsjednik inv. komisije",
          inputs: [{
            type: "input",
            required: true,
            placeholder: "Ime i prezime",
            label: "Ime i prezime",
            inSignature: true,
          },
          {
            type: "input",
            required: true,
            placeholder: "Ulica i kućni broj",
          },
          {
            type: "input",
            required: true,
            placeholder: "Mjesto",
          },
          {
            type: "input",
            required: true,
            placeholder: "OIB",
          }],
          suffix: " (u daljnjem tekstu: Predsjednik inv. komisije)",
          delimiter: `i`
        },
        {
          signature: "Član inv. komisije",
          inputs: [{
            type: "input",
            required: true,
            placeholder: "Ime i prezime",
            label: "Ime i prezime",
            inSignature: true,
          },
          {
            type: "input",
            required: true,
            placeholder: "Ulica i kućni broj",
          },
          {
            type: "input",
            required: true,
            placeholder: "Mjesto",
          },
          {
            type: "input",
            required: true,
            placeholder: "OIB",
          }],
          suffix: " (u daljnjem tekstu: Član inv. komisije)",
          delimiter: `i`
        },
        {
          signature: "Član inv. komisije",
          inputs: [{
            type: "input",
            required: true,
            placeholder: "Ime i prezime",
            label: "Ime i prezime",
            inSignature: true,
          },
          {
            type: "input",
            required: true,
            placeholder: "Ulica i kućni broj",
          },
          {
            type: "input",
            required: true,
            placeholder: "Mjesto",
          },
          {
            type: "input",
            required: true,
            placeholder: "OIB",
          },
          ],
       suffix: " (u daljnjem tekstu: Član inv. komisije); ",
        }
      ],
  headline: 'dalje u tekstu: Komisija,  ​podnosi sljedeći',
  title: 'IZVJEŠTAJ O PROVEDENOM POPISU IMOVINE I OBVEZA',
  noArticleNumbers: true,

  articles: [
    {
      title: 'UVODNE ODREDBE',
      mandatory: false,
      exampleContent:true,
      statements: [
          {
              type: 'text',
              required: true,
              mandatory: true,
              editable: true,
              content: 'Sukladno Odluci o provođenju popisa imovine i obveza te imenovanju komisije za popis imovine izvršen je popis imovine s danom __.__.20__.                ',
              value: '',
          },
      ],
      value: '',
  },
    {
      title: '',
      mandatory: false,
      exampleContent:true, 
      statements: [
          {
              type: 'text',
              required: true,
              mandatory: true,
              editable: true,
              content: 'Ovim Izvještajem, inventurna komisija podnosi stvarna stanja imovine i obveza te prikazuje stanja imovine i obveza u poslovnim knjigama odnosno utvrđuje popisne razlike.',
              value: '',
          },
      ],
      value: '',
  }, 
  {
    title: 'POPIS DUGOTRAJNE IMOVINE',
    mandatory: false,
    exampleContent:true, 
    statements: [
        {
            type: 'text',
            required: true,
            mandatory: true,
            editable: true,
            content: 'Komisija za popis imovine utvrdila je stvarno stanje dugotrajne imovine koje iznosi: \r\n- za osnovna sredstva = ________ kn \r\n- za sitan inventar = ________ kn. \r\nU Privitku ovog Izvještaja dostavljaju se inventurne liste izvršenog popisa dugotrajne imovine. ',
            help: "U slučaju da se da poduzetnik slučajno ne posjeduje dugotrajnu imovinu ili sitni inventar samo se konstatira da poduzetnik ne posjeduje dugotrajnu imovinu – inventar ili sitni inventar te da sukladno tome, popis imovine nije izvršen.",
            value: '',
          },
      ],
      value: '',
  }, 
{
  title: 'POPIS REPROMATERIJALA NA SKLADIŠTU',
  mandatory: false,
  exampleContent:true, 
  statements: [
      {
          type: 'text',
          required: true,
          mandatory: true,
          editable: true,
          content: 'Inventurno stanje repromaterijala prilaže se u Privitku ovog Izvještaja i čini njegov sastavni dio.',
          value: '',
      },
  ],
  value: '',
},
{
title: 'POPIS POTRAŽIVANJA OD KUPACA',
mandatory: false,
exampleContent:true, 
statements: [
    {
        type: 'text',
        required: true,
        mandatory: true,
        editable: true,
        content: 'Utvrđuje se da su svim kupcima poslani IOS-i na usklađenje salda konto stavaka na dan 31.12..',
        value: '',
    },
],
value: '',
},  
{
title: 'POPIS POTRAŽIVANJA OD RADNIKA',
mandatory: true,
statements: [
    {
        type: 'choice',
        mandatory: true,
        editable: true,
        choices: [
            'Utvrđuje se da ne postoje potraživanja od radnika.',
            'Utvrđuje se da postoje potraživanja od radnika te da ona iznose ________ kn.',
          ],
        placeholder: "Odaberite ovdje te potom izmijenite po želji...",
    }
]
},
{
title: 'POPIS POTRAŽIVANJA OD ČLANOVA DRUŠTVA',
mandatory: true,
statements: [
    {
        type: 'choice',
        mandatory: true,
        editable: true,
        choices: [
            'Utvrđuje se da ne postoje potraživanja od članova društva.',
            'Utvrđuje se da postoje potraživanja od članova društva te da ona iznose ________ kn',
          ],
        placeholder: "Odaberite ovdje te potom izmijenite po želji...",
    }
]
},
{
title: 'POPIS NOVČANIH SREDSTAVA NA ŽIRO RAČUNIMA',
mandatory: false,
exampleContent:true, 
statements: [
    {
        type: 'text',
        required: true,
        mandatory: true,
        editable: true,
        content: 'Utvrđuje se sljedeće stanje na žiro računu, IBAN broj: ____________________ u iznosu od__________ , na dan 31.12. godine poreznog razdoblja.',
        value: '',
    },
],
value: '',
}, 
{
title: 'POPIS NOVČANIH SREDSTAVA U BLAGAJNAMA',
mandatory: false,
exampleContent:true, 
statements: [
    {
        type: 'text',
        required: true,
        mandatory: true,
        editable: true,
        content: 'Utvrđuje se sljedeće stanje u blagajni pod nazivom _____________ u iznosu od__________ na dan 31.12. godine poreznog razdoblja.',
        value: '',
    },
],
value: '',
}, 
{
title: 'POPIS OSTALIH POTRAŽIVANJA - DANIH ZAJMOVA, DANIH PREDUJMOVA, DANIH GARANCIJA, DANIH JAMČEVINA',
mandatory: false,
exampleContent:true, 
statements: [
    {
        type: 'text',
        required: true,
        mandatory: true,
        editable: true,
        content: 'Utvrđuje se sljedeće stanje na dan 31.12. godine poreznog razdoblja: \r\n- dani zajmovi: _____________ kn, \r\n- dani predujmovi: _____________ kn, \r\n- dani garancije: _____________ kn, \r\n- dane jamčevine: _____________ kn.',
        value: '',
    },
],
value: '',
}, 
{
title: 'POPIS OBVEZA - PREMA DOBAVLJAČIMA, PREMA RADNICIMA, PREMA POREZNOJ UPRAVI, PREMA KREDITNIM INSTITUCIJAMA (DUGOROČNI I KRATKOROČNI ZAJMOVI) I OBVEZA ZA LEASING (OPERATIVNI ILI FINANCIJSKI)',
mandatory: false,
exampleContent:true, 
statements: [
    {
        type: 'text',
        required: true,
        mandatory: true,
        editable: true,
        content: 'Utvrđuje se sljedeće stanje na dan 31.12. godine poreznog razdoblja: \r\n- obveze prema dobavljačima: _____________ kn, \r\n- obveze prema radnicima – plaća za mjesec prosinac poreznog razdoblja: _____________ kn, \r\n- obveze prema poreznoj upravi prema priloženoj PKK kartici: _____________ kn, \r\n- prema kreditnim institucijama prema povrdama istih: _____________ kn, \r\n- obveze za leasing prema povrdama leasing kuća: _____________ kn.',
        value: '',
    },
],
value: '',
}, 
{
  title: '',
  mandatory: false,
  exampleContent:true, 
  statements: [
    {
      type: 'text',
      required: true,
      mandatory: true,
      editable: true,
      content: 'Potpisom ovog Izvještaja članovi inventurne komisije preuzimaju odgovornost za točnost podataka navedenih u Izvještaju.',
      value: '',
  },
    ],
},
  {
    mandatory: true,
    static: true,
    type: 2, // date and place
    statements: [
      {
        type: "input",
        mandatory: true,
        parts: [
          {
            type: "text",
            content: "U"
          },
          {
            type: "input",
            value: "",
            placeholder: "Upišite mjesto.",
            required: true,
          },
          {
            type: "text",
            content: ", dana"
          },
          {
            type: "date",
            value: new Date(),
            required: true
          },
          {
            type: "text",
            content: "godine."
          }
        ]
      },
    ]
  },
  {
    mandatory: true,
    static: true,
    type: 3,  // signature
    statements: [],
  }
]
}










// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/209_izvjestaj_inventura.ts